"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const function_1 = require("fp-ts/lib/function");
const t = require("io-ts");
const E = require("fp-ts/lib/Either");
const pipeable_1 = require("fp-ts/lib/pipeable");
const time_1 = require("../time");
class LocalDateType extends t.Type {
    constructor() {
        super('LocalDate', (u) => u instanceof time_1.LocalDate, (u, c) => this.is(u) ? t.success(u) : t.failure(u, c), function_1.identity);
        this._tag = 'LocalDateType';
    }
}
const localDate = new LocalDateType();
exports.localDateFromString = new t.Type('LocalDateFromString', localDate.is, (u, c) => pipeable_1.pipe(t.string.validate(u, c), E.chain(s => pipeable_1.pipe(time_1.LocalDate.parse(s), E.fold(e => t.failure(e, c, 'cannot parse to local date'), a => t.success(a))))), x => x.format('iso'));
class DateTimeType extends t.Type {
    constructor() {
        super('DateTime', (u) => u instanceof time_1.DateTime, (u, c) => this.is(u) ? t.success(u) : t.failure(u, c), function_1.identity);
        this._tag = 'DateTimeType';
    }
}
const dateTime = new DateTimeType();
exports.dateTimeFromString = new t.Type('DateTimeFromString', dateTime.is, (u, c) => pipeable_1.pipe(t.string.validate(u, c), E.chain(s => pipeable_1.pipe(time_1.DateTime.parse(s), E.fold(e => t.failure(e, c, 'cannot parse to date time'), a => t.success(a))))), x => x.format('iso'));
